import React from 'react';

/**
 * Three-point lighting rig: key light, cool fill light, and a rim/back light.
 * Used automatically when no `environment` preset is provided.
 * All intensities are configurable; shadow maps are 2048×2048.
 */
function ViewerLights({
  ambientIntensity = 0.8,
  directionalIntensity = 3,
  pointIntensity = 2,
  shadows = true,
}) {
  return (
    <>
      <ambientLight intensity={ambientIntensity} />

      {/* Key light — main illumination from front-right-top */}
      <directionalLight
        position={[4, 6, 4]}
        intensity={directionalIntensity}
        castShadow={shadows}
        shadow-mapSize={[2048, 2048]}
        shadow-camera-near={0.1}
        shadow-camera-far={50}
        shadow-camera-left={-10}
        shadow-camera-right={10}
        shadow-camera-top={10}
        shadow-camera-bottom={-10}
      />

      {/* Fill light — cool blue from back-left to separate subject from bg */}
      <directionalLight
        position={[-4, 2, -4]}
        intensity={directionalIntensity * 0.4}
        color="#b4d4ff"
      />

      {/* Rim light — back-top highlight to define silhouette */}
      <pointLight position={[0, 6, -4]} intensity={pointIntensity} color="#ffffff" />
    </>
  );
}

export default ViewerLights;
